<template>
  <div class="retain-contaienr"
       data-sensors-exposure-event-name="Element_Exposure"  
       data-sensors-exposure-property-caseId="mLlTopLottie"
       :data-sensors-exposure-property-caseBizType="oldPreviewFloatViewResp.caseBizType"
  >
    <div class="animation-container">
      <vue-lottie :options="lottieOptions" ref="lottie1" v-show="oldPreviewFloatViewResp && oldPreviewFloatViewResp.caseBizType === 'OLD_PREVIEW_A'"></vue-lottie>
      <vue-lottie :options="lottieOptions2" ref="lottie2" v-show="oldPreviewFloatViewResp && oldPreviewFloatViewResp.caseBizType === 'OLD_PREVIEW_B'"></vue-lottie>
    </div>
    <p class="title">提现金额(元)</p>
    <p class="amt">{{ amt | currency }}</p>
  </div>
</template>

<script>
import VueLottie from 'vue-lottie'
import gaotong from './json/gaotong'
import mianxi from './json/mianxi'
export default {
  components: {
    VueLottie
  },
  data () {
    return {
      lottieOptions: {
        animationData: mianxi, loop: false, autoplay: false
      },
      lottieOptions2: {
        animationData: gaotong, loop: false, autoplay: false
      }
    }
  },
  props: {
    amt: {
      type: [String, Number],
      default: 0
    },
    oldPreviewFloatViewResp: {
      type: Object,
      default: () => ({})
    }
  },

  mounted () {
    setTimeout(() => {
      this.$refs.lottie1.anim.play()
      this.$refs.lottie2.anim.play()
    }, 500)
  } 
}
</script>

<style lang="scss" scoped>
.retain-contaienr{
  height: 480px;
  background: url(./images/01@2x.png) no-repeat;
  background-size: 100% 100%;
  margin-bottom: -20px;
  position: relative;
  padding-top: 80px;
  .title {
    position: relative;
    text-align: center;
    font-size: 28px;
    width: 100%;
    color: #FFFFFF;
  }
  .amt {
    position: relative;
    font-family: DIN, DIN;
    font-weight: 500;
    font-size: 80px;
    color: #FFFFFF;
    text-align: center;
  }
  .animation-container {
    position: absolute;
    left: 0;
    top:0;
    width: 100%;
    height: 100%;
  }
}
</style>